export default __webpack_public_path__ + "static/media/59.0bbe5ebc.png";